export const API_URL = import.meta.env.PROD
  ? "https://ui.trinitalkbot.com/api"
  : "http://127.0.0.1:8000";
// : "http://localhost:8000/";

export const WS_URL = import.meta.env.PROD
  ? "https://ui.trinitalkbot.com/"
  : "http://localhost:8001/";

export const ERROR_MONITOR_DSN = import.meta.env.VITE_SENTRY_DSN;